import { err, ok, Result } from "neverthrow"
import { CalcScriptLexer } from "./Lexer"
import type { CalcScriptCompileError, CompiledCalcScript } from "./CompilerTypes"
import { CalcScriptCompileEnv } from "./CompileEnv"
import { CalcScriptParser } from "./Parser"
import { CalcScriptConceptCollector } from "./ConceptCollector"

export class CalcScriptCompiler {
	compile(script: string): Result<CompiledCalcScript, CalcScriptCompileError> {
		const rTokenize = new CalcScriptLexer().tokenize(script)
		if(rTokenize.isErr()) {
			return err(rTokenize.error)
		}
		const tokens = rTokenize.value
		const environment = new CalcScriptCompileEnv()
		const rParse = new CalcScriptParser(tokens, environment).parse()
		if(rParse.isErr()) {
			return err(rParse.error)
		}
		const { programNode, calcType } = rParse.value
		const rCollect = new CalcScriptConceptCollector(programNode, environment).collect()
		if(rCollect.isErr()) {
			return err(rCollect.error)
		}
		return ok({
			calcType,
			concepts: rCollect.value,
			programNode,
		})
	}
}
